import React from 'react'

import EChartsReact from 'echarts-for-react'
import { graphic } from 'echarts'

import { percentFormatterLocaleAware } from '../../helpers/utils/numberFormatters'
import useWindowSize from '../../helpers/utils/useWindowSize'

const formatter = new Intl.NumberFormat(undefined, { maximumFractionDigits: 1 })

const chartSize = (windowWidth) => {
  let width = 371
  let height = 292

  if (windowWidth < 1280 && windowWidth > 920) {
    width = 280
    height = 220
  } else if (windowWidth <= 1680) {
    width = 317
    height = 250
  }

  return { width, height }
}

export default function Chart({ className, timePercent, speed }) {
  const { width } = useWindowSize()

  const option = {
    dataset: [
      {
        source: [{ speed }],
      },
      {
        source: [{ time: timePercent }],
      },
    ],
  }

  return (
    <EChartsReact
      className={className}
      option={{ ...baseOption, ...option }}
      style={{ ...chartSize(width) }}
    />
  )
}

const textureSrc = (windowWidth, color) => {
  let src = `<svg width="252" height="292" viewBox="0 0 252 292" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M43.7482 281.753L26.478 291.839C25.1029 289.485 23.7792 287.104 22.5074 284.699L40.1871 275.349C41.3278 277.506 42.515 279.641 43.7482 281.753ZM36.8986 268.801L18.8408 277.398C17.6693 274.938 16.5505 272.454 15.4851 269.95L33.8888 262.121C34.8445 264.367 35.8479 266.594 36.8986 268.801ZM31.163 255.319L12.446 262.367C11.4861 259.818 10.5802 257.249 9.72883 254.663L28.7259 248.409C29.4896 250.729 30.3021 253.033 31.163 255.319ZM26.5818 241.403L7.3383 246.852C6.59653 244.232 5.90981 241.596 5.27868 238.946L24.7344 234.312C25.3005 236.689 25.9165 239.053 26.5818 241.403ZM23.1872 227.151L3.55361 230.961C3.03501 228.29 2.57235 225.605 2.16618 222.911L21.9428 219.93C22.3071 222.347 22.722 224.754 23.1872 227.151ZM21.0035 212.663L1.11892 214.808C0.827104 212.103 0.591912 209.39 0.41388 206.669L20.3712 205.363C20.5309 207.803 20.7418 210.237 21.0035 212.663ZM20.0469 198.043L0.0522604 198.508C-0.0108633 195.789 -0.0168982 193.065 0.0346727 190.338L20.0311 190.716C19.9848 193.162 19.9903 195.605 20.0469 198.043ZM20.3238 183.394L0.361056 182.175C0.444005 180.817 0.541306 179.459 0.653022 178.1C0.764737 176.742 0.890641 175.386 1.03064 174.033L20.9245 176.091C20.7989 177.305 20.686 178.521 20.5857 179.739C20.4855 180.958 20.3982 182.176 20.3238 183.394ZM21.8318 168.819L2.04221 165.926C2.43686 163.227 2.88778 160.541 3.39417 157.869L23.0443 161.593C22.5902 163.99 22.1857 166.399 21.8318 168.819ZM24.5601 154.425L5.08421 149.876C5.7043 147.221 6.37964 144.583 7.1094 141.962L26.3764 147.327C25.7219 149.677 25.1162 152.044 24.5601 154.425ZM28.4902 140.311L9.46626 134.139C10.3072 131.547 11.2022 128.974 12.1503 126.423L30.8975 133.39C30.0472 135.678 29.2445 137.986 28.4902 140.311ZM33.594 126.577L15.1566 118.827C16.2122 116.316 17.3202 113.828 18.48 111.365L36.5748 119.884C35.5346 122.093 34.5407 124.325 33.594 126.577ZM39.8348 113.322L22.1146 104.049C23.377 101.636 24.6903 99.2501 26.0538 96.892L43.368 106.903C42.1451 109.018 40.9671 111.158 39.8348 113.322ZM47.1683 100.638L30.2908 89.9075C31.7511 87.6107 33.2605 85.3434 34.8182 83.1073L51.2289 94.5392C49.8318 96.5448 48.478 98.5783 47.1683 100.638ZM55.543 88.6162L39.6283 76.5034C41.2759 74.3386 42.9707 72.2063 44.7119 70.1083L60.1023 82.8807C58.5408 84.7624 57.0208 86.6747 55.543 88.6162ZM64.8992 77.3423L50.0603 63.933C51.8835 61.9155 53.7517 59.9334 55.6641 57.9884L69.9251 72.0106C68.2099 73.7551 66.5343 75.5328 64.8992 77.3423ZM75.1715 66.8949L61.5134 52.2849C62.5071 51.3558 63.5116 50.4364 64.5267 49.5266C65.5418 48.6169 66.5655 47.7188 67.5975 46.8324L80.629 62.0041C79.7033 62.7992 78.7851 63.6048 77.8745 64.4208C76.964 65.2368 76.0629 66.0616 75.1715 66.8949ZM86.2869 57.3476L73.9055 41.6409C76.0477 39.9522 78.2219 38.3116 80.4265 36.7196L92.1355 52.9338C90.1583 54.3616 88.2082 55.8331 86.2869 57.3476ZM98.1645 48.7703L87.1488 32.0774C89.4244 30.5757 91.7289 29.1238 94.0606 27.7224L104.364 44.8645C102.272 46.1214 100.205 47.4235 98.1645 48.7703ZM110.722 41.2229L101.15 23.6621C103.543 22.3579 105.962 21.105 108.404 19.9042L117.228 37.8524C115.037 38.9294 112.868 40.0531 110.722 41.2229ZM123.87 34.7588L115.81 16.4551C118.302 15.3573 120.818 14.3123 123.353 13.3208L130.636 31.9476C128.362 32.8369 126.106 33.7742 123.87 34.7588ZM137.515 29.4236L131.023 10.5068C133.598 9.62287 136.192 8.79308 138.803 8.01803L144.494 27.1913C142.152 27.8865 139.825 28.6308 137.515 29.4236ZM151.561 25.2548L146.682 5.85898C149.322 5.19508 151.976 4.58636 154.645 4.03346L158.703 23.6175C156.309 24.1134 153.928 24.6594 151.561 25.2548ZM165.907 22.2824L162.678 2.54478C165.363 2.10552 168.06 1.72232 170.766 1.39581L173.162 21.2519C170.734 21.5447 168.315 21.8884 165.907 22.2824ZM180.453 20.5278L178.896 0.588526C181.607 0.376867 184.326 0.221926 187.052 0.124313L187.768 20.1115C185.323 20.1991 182.884 20.338 180.453 20.5278ZM195.095 20.0035L195.221 0.00390625C196.581 0.0124912 197.943 0.0353832 199.306 0.0726604C200.668 0.109936 202.029 0.161518 203.388 0.227322L202.42 20.2039C201.202 20.1449 199.981 20.0986 198.759 20.0652C197.536 20.0317 196.315 20.0112 195.095 20.0035ZM209.73 20.7123L211.538 0.794157C214.254 1.04066 216.961 1.34404 219.657 1.7036L217.012 21.528C214.595 21.2055 212.167 20.9334 209.73 20.7123ZM224.253 22.6496L227.73 2.95414C230.415 3.42814 233.086 3.9582 235.743 4.54359L231.439 24.0751C229.057 23.5501 226.661 23.0747 224.253 22.6496ZM238.561 25.8022L243.683 6.46924C246.317 7.16721 248.935 7.92017 251.534 8.72738L245.602 27.8275C243.271 27.1035 240.923 26.4282 238.561 25.8022Z" fill="${color}"/>
</svg>`

  if (windowWidth < 1280) {
    src = `<svg width="191" height="221" viewBox="0 0 191 221" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M33.6 212.752L20.5927 220.349C19.557 218.576 18.5601 216.783 17.6021 214.971L30.9179 207.929C31.777 209.554 32.6712 211.162 33.6 212.752ZM28.4411 202.997L14.8406 209.473C13.9583 207.619 13.1157 205.749 12.3132 203.863L26.1743 197.966C26.894 199.658 27.6497 201.335 28.4411 202.997ZM24.1213 192.843L10.0243 198.152C9.30132 196.232 8.61903 194.297 7.9778 192.349L22.2857 187.639C22.8609 189.386 23.4729 191.121 24.1213 192.843ZM20.6708 182.362L6.17734 186.466C5.61866 184.493 5.10145 182.508 4.62611 180.512L19.2795 177.022C19.7058 178.812 20.1697 180.592 20.6708 182.362ZM18.1142 171.628L3.32685 174.498C2.93625 172.486 2.5878 170.464 2.28188 168.434L17.1769 166.189C17.4513 168.01 17.7638 169.823 18.1142 171.628ZM16.4695 160.716L1.49312 162.332C1.27334 160.295 1.0962 158.251 0.962111 156.202L15.9933 155.218C16.1135 157.056 16.2724 158.889 16.4695 160.716ZM15.749 149.705L0.689751 150.055C0.642209 148.007 0.637663 145.956 0.676505 143.902L15.7371 144.187C15.7023 146.029 15.7063 147.869 15.749 149.705ZM15.9576 138.672L0.922325 137.754C0.984799 136.731 1.05808 135.708 1.14222 134.685C1.22636 133.662 1.32119 132.64 1.42663 131.621L16.41 133.171C16.3154 134.085 16.2303 135.001 16.1548 135.919C16.0794 136.837 16.0136 137.755 15.9576 138.672ZM17.0933 127.695L2.18851 125.515C2.48575 123.483 2.82536 121.459 3.20676 119.447L18.0066 122.252C17.6645 124.057 17.3599 125.871 17.0933 127.695ZM19.1482 116.853L4.47964 113.427C4.94667 111.428 5.45531 109.44 6.00494 107.466L20.5162 111.507C20.0232 113.277 19.567 115.06 19.1482 116.853ZM22.1082 106.223L7.78005 101.575C8.41342 99.6223 9.08746 97.6848 9.80155 95.7633L23.9213 101.011C23.2808 102.734 22.6763 104.472 22.1082 106.223ZM25.9522 95.8794L12.0658 90.0423C12.8608 88.1511 13.6954 86.2772 14.5689 84.4218L28.1973 90.8382C27.4138 92.5023 26.6652 94.1831 25.9522 95.8794ZM30.6526 85.8959L17.3063 78.9116C18.2571 77.0947 19.2463 75.2976 20.2732 73.5215L33.3136 81.0613C32.3926 82.6543 31.5054 84.2662 30.6526 85.8959ZM36.1759 76.3431L23.4643 68.261C24.5642 66.5312 25.701 64.8235 26.8742 63.1393L39.2342 71.7494C38.182 73.26 37.1623 74.7916 36.1759 76.3431ZM42.4834 67.2885L30.497 58.1655C31.738 56.5351 33.0144 54.9291 34.3258 53.349L45.9174 62.9687C44.7412 64.3859 43.5964 65.8262 42.4834 67.2885ZM49.5301 58.7974L38.354 48.698C39.7272 47.1784 41.1343 45.6856 42.5746 44.2207L53.3155 54.7817C52.0237 56.0956 50.7617 57.4345 49.5301 58.7974ZM57.2669 50.9288L46.9801 39.925C47.7286 39.2253 48.4851 38.5328 49.2497 37.8476C50.0142 37.1624 50.7852 36.486 51.5624 35.8184L61.3773 47.2452C60.6801 47.844 59.9885 48.4507 59.3027 49.0654C58.6169 49.68 57.9383 50.3012 57.2669 50.9288ZM65.6386 43.7381L56.3134 31.9083C57.9268 30.6365 59.5644 29.4008 61.2248 28.2018L70.0435 40.4137C68.5544 41.4891 67.0857 42.5974 65.6386 43.7381ZM74.5844 37.278L66.2878 24.7054C68.0017 23.5744 69.7374 22.4809 71.4935 21.4254L79.2533 34.3362C77.6782 35.2829 76.1215 36.2636 74.5844 37.278ZM84.0423 31.5935L76.8332 18.3674C78.6354 17.385 80.4569 16.4414 82.2965 15.537L88.9424 29.055C87.2925 29.8661 85.6587 30.7125 84.0423 31.5935ZM93.945 26.725L87.874 12.9393C89.7516 12.1124 91.6459 11.3254 93.5558 10.5786L99.0412 24.6077C97.3281 25.2775 95.629 25.9834 93.945 26.725ZM104.222 22.7067L99.332 8.45921C101.272 7.79349 103.225 7.16852 105.192 6.58478L109.478 21.0254C107.714 21.549 105.962 22.1096 104.222 22.7067ZM114.801 19.5669L111.126 4.95866C113.114 4.45863 115.114 4.00017 117.124 3.58375L120.18 18.3338C118.377 18.7073 116.584 19.1185 114.801 19.5669ZM125.606 17.3282L123.174 2.46252C125.196 2.13169 127.227 1.84308 129.266 1.59716L131.07 16.552C129.241 16.7726 127.42 17.0314 125.606 17.3282ZM136.561 16.0067L135.388 0.989143C137.43 0.829729 139.478 0.713033 141.531 0.639514L142.071 15.6932C140.229 15.7591 138.392 15.8638 136.561 16.0067ZM147.589 15.6118L147.684 0.548828C148.709 0.555294 149.734 0.572535 150.76 0.600611C151.787 0.628686 152.811 0.667536 153.835 0.717097L153.106 15.7628C152.188 15.7183 151.269 15.6835 150.348 15.6583C149.428 15.6331 148.508 15.6176 147.589 15.6118ZM158.612 16.1457L159.973 1.14402C162.019 1.32967 164.058 1.55817 166.088 1.82898L164.096 16.76C162.275 16.5171 160.447 16.3122 158.612 16.1457ZM169.549 17.6047L172.168 2.77084C174.19 3.12784 176.203 3.52706 178.204 3.96796L174.962 18.6784C173.168 18.283 171.363 17.9249 169.549 17.6047ZM180.326 19.9792L184.184 5.41829C186.168 5.94397 188.139 6.51107 190.097 7.11904L185.629 21.5046C183.874 20.9593 182.105 20.4507 180.326 19.9792Z" fill="${color}"/>
</svg>`
  } else if (windowWidth <= 1680) {
    src = `<svg width="216" height="251" viewBox="0 0 216 251" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M37.8896 241.701L23.1333 250.32C21.9585 248.308 20.8275 246.274 19.7408 244.219L34.8469 236.23C35.8215 238.073 36.8359 239.897 37.8896 241.701ZM32.037 230.635L16.6079 237.981C15.6069 235.879 14.651 233.757 13.7407 231.617L29.4654 224.927C30.2819 226.846 31.1393 228.75 32.037 230.635ZM27.1364 219.116L11.144 225.138C10.3238 222.96 9.54981 220.765 8.82237 218.555L25.0541 213.212C25.7065 215.194 26.4008 217.162 27.1364 219.116ZM23.222 207.225L6.77983 211.881C6.14604 209.643 5.55928 207.391 5.02003 205.126L21.6436 201.167C22.1273 203.198 22.6536 205.218 23.222 207.225ZM20.3216 195.048L3.54608 198.304C3.10297 196.021 2.70766 193.728 2.36062 191.425L19.2584 188.878C19.5696 190.943 19.9242 193 20.3216 195.048ZM18.4558 182.669L1.46581 184.502C1.21647 182.191 1.01551 179.872 0.863398 177.548L17.9155 176.432C18.052 178.517 18.2322 180.596 18.4558 182.669ZM17.6384 170.178L0.554418 170.574C0.500484 168.252 0.495327 165.924 0.539391 163.594L17.6249 163.917C17.5854 166.007 17.59 168.094 17.6384 170.178ZM17.8751 157.661L0.818263 156.619C0.889137 155.459 0.972274 154.298 1.06773 153.138C1.16318 151.977 1.27076 150.818 1.39037 149.662L18.3883 151.421C18.281 152.458 18.1845 153.497 18.0988 154.538C18.0132 155.579 17.9386 156.621 17.8751 157.661ZM19.1635 145.208L2.25469 142.736C2.59189 140.429 2.97717 138.134 3.40985 135.851L20.1995 139.034C19.8115 141.081 19.4659 143.14 19.1635 145.208ZM21.4946 132.909L4.85387 129.022C5.3837 126.754 5.96072 124.499 6.58425 122.26L23.0466 126.844C22.4873 128.852 21.9698 130.874 21.4946 132.909ZM24.8527 120.849L8.59803 115.576C9.31656 113.361 10.0812 111.163 10.8913 108.983L26.9096 114.936C26.183 116.891 25.4971 118.863 24.8527 120.849ZM29.2135 109.115L13.4601 102.493C14.3619 100.347 15.3087 98.2216 16.2997 96.1168L31.7604 103.396C30.8716 105.284 30.0224 107.191 29.2135 109.115ZM34.5458 97.7891L19.4051 89.8657C20.4838 87.8045 21.6059 85.7658 22.7709 83.7509L37.5647 92.3045C36.5198 94.1117 35.5133 95.9403 34.5458 97.7891ZM40.8118 86.9519L26.3911 77.7831C27.6389 75.8207 28.9285 73.8835 30.2595 71.9728L44.2813 81.7406C43.0876 83.4542 41.9309 85.1917 40.8118 86.9519ZM47.9674 76.6799L34.3694 66.3303C35.7772 64.4806 37.2253 62.6587 38.713 60.8661L51.863 71.7792C50.5288 73.387 49.23 75.0209 47.9674 76.6799ZM55.9616 67.0471L43.2828 55.5898C44.8406 53.8659 46.4368 52.1724 48.0709 50.5105L60.2559 62.4915C58.7904 63.9821 57.3587 65.501 55.9616 67.0471ZM64.7386 58.1205L53.0686 45.6372C53.9178 44.8434 54.776 44.0578 55.6434 43.2805C56.5107 42.5032 57.3853 41.7359 58.2671 40.9785L69.4016 53.9416C68.6107 54.621 67.8262 55.3093 67.0481 56.0065C66.2701 56.7038 65.5002 57.4085 64.7386 58.1205ZM74.2359 49.963L63.6569 36.5427C65.4873 35.0999 67.345 33.6981 69.2286 32.3378L79.2331 46.1917C77.5437 47.4117 75.8776 48.6689 74.2359 49.963ZM84.3845 42.6343L74.9723 28.3714C76.9167 27.0883 78.8857 25.8478 80.878 24.6503L89.6811 39.297C87.8943 40.371 86.1283 41.4836 84.3845 42.6343ZM95.1141 36.1855L86.9356 21.1811C88.9802 20.0667 91.0466 18.9962 93.1335 17.9702L100.673 33.3057C98.8012 34.2259 96.9478 35.186 95.1141 36.1855ZM106.348 30.6625L99.4609 15.0232C101.591 14.0852 103.74 13.1923 105.907 12.3452L112.13 28.2604C110.186 29.0203 108.259 29.8211 106.348 30.6625ZM118.007 26.1038L112.459 9.94076C114.66 9.18553 116.876 8.47654 119.108 7.81431L123.97 24.1966C121.969 24.7905 119.981 25.4265 118.007 26.1038ZM130.008 22.542L125.839 5.96955C128.095 5.40229 130.363 4.88218 132.643 4.40977L136.11 21.143C134.065 21.5667 132.031 22.0332 130.008 22.542ZM142.266 20.0022L139.507 3.1378C141.801 2.76248 144.105 2.43506 146.418 2.15608L148.464 19.1217C146.39 19.3719 144.324 19.6656 142.266 20.0022ZM154.694 18.5031L153.364 1.46631C155.68 1.28547 158.004 1.15308 160.333 1.06968L160.944 18.1473C158.855 18.2221 156.771 18.3409 154.694 18.5031ZM167.205 18.0551L167.313 0.966797C168.475 0.974132 169.638 0.993692 170.803 1.02554C171.967 1.05739 173.129 1.10147 174.29 1.15769L173.464 18.2263C172.422 18.1759 171.38 18.1363 170.335 18.1078C169.291 18.0792 168.247 18.0616 167.205 18.0551ZM179.71 18.6607L181.254 1.64201C183.575 1.85263 185.888 2.11185 188.191 2.41907L185.931 19.3576C183.866 19.0821 181.792 18.8496 179.71 18.6607ZM192.118 20.3159L195.089 3.48756C197.383 3.89257 199.666 4.34547 201.936 4.84564L198.259 21.5339C196.223 21.0854 194.175 20.6792 192.118 20.3159ZM204.343 23.0096L208.72 6.49098C210.971 7.08734 213.207 7.73069 215.428 8.4204L210.36 24.7401C208.368 24.1215 206.362 23.5445 204.343 23.0096Z" fill="${color}"/>
</svg>`
  }

  return src
}

const makeTexture = (windowWidth, color) => {
  const texture = new Image()
  texture.src = `data:image/svg+xml;utf8,${textureSrc(windowWidth, color)}`

  return texture
}

const backgroundColor = 'rgba(57, 64, 69, 0.5)'
const progressColor = 'rgba(119, 196, 128, 1)'

const texture = makeTexture(1920, backgroundColor)
const frontTexture = makeTexture(1920, progressColor)

const texture1680 = makeTexture(1680, backgroundColor)
const frontTexture1680 = makeTexture(1680, progressColor)

const texture1279 = makeTexture(1279, backgroundColor)
const frontTexture1279 = makeTexture(1279, progressColor)

const center = [196, 195]
const centerMiddle = [165, 167]
const centerSmall = [139, 140]

const startAngle = 210
const endAngle = -30
const speedMaxGaugeValue = 23

const baseOption = {
  title: {
    text: 'ongoing allocation',
    left: 120,
    bottom: '5%',
    textStyle: {
      fontWeight: '300',
    },
  },
  dataset: [
    {
      source: [{ speed: 0 }],
    },
    {
      source: [{ time: 0 }],
    },
  ],
  series: [
    {
      name: 'epoch',
      type: 'gauge',
      min: 0,
      max: 1,
      radius: 190,
      startAngle,
      endAngle: 70,
      center,
      axisLine: {
        lineStyle: {
          width: 100,
          color: [
            [
              1,
              {
                image: texture,
              },
            ],
          ],
        },
      },
      axisLabel: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      pointer: {
        show: false,
      },
      splitLine: {
        show: false,
      },
      progress: {
        show: true,
        width: 16,
        itemStyle: {
          color: {
            image: frontTexture,
          },
        },
      },
      detail: {
        valueAnimation: true,
        precision: 3,
        offsetCenter: [120, -160],
        color: '#77C480',
        fontWeight: 200,
        fontSize: 40,
        lineHeight: 24,
        formatter: (value) =>
          `${percentFormatterLocaleAware.format(value)}\n{small|OCX allocated}`,
        rich: {
          small: {
            color: '#77C480',
            fontSize: 14,
          },
        },
      },
      title: {
        offsetCenter: [0, '70%'],
      },
      datasetIndex: 1,
      encode: {
        value: 'time',
      },
    },
    {
      name: 'line',
      type: 'gauge',
      startAngle,
      endAngle,
      radius: 90,
      center,
      axisLine: {
        lineStyle: {
          color: [[1, '#2B2F32']],
          width: 2,
        },
      },
      axisLabel: {
        show: false,
      },
      splitLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      pointer: {
        show: false,
      },
      detail: {
        show: false,
      },
    },
    {
      name: 'shadow',
      type: 'gauge',
      min: 0,
      max: speedMaxGaugeValue,
      startAngle,
      endAngle,
      radius: 150,
      center,
      axisTick: {
        show: false,
      },
      splitLine: {
        show: false,
      },
      axisLabel: {
        show: false,
      },
      axisLine: {
        show: false,
      },
      pointer: {
        show: false,
      },
      title: {
        show: false,
      },
      detail: {
        show: false,
      },
      progress: {
        show: true,
        width: 60,
        itemStyle: {
          color: new graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: 'rgba(181, 247, 255, 0.25)',
            },
            {
              offset: 1,
              color: 'rgba(181, 247, 255, 0.01)',
            },
          ]),
        },
      },
      encode: {
        value: 'speed',
      },
    },
    {
      name: 'speed',
      type: 'gauge',
      min: 0,
      max: speedMaxGaugeValue,
      splitNumber: 21,
      startAngle,
      endAngle,
      radius: 160,
      center,
      axisLine: {
        lineStyle: {
          color: [[1, '#2B2F32']],
          width: 14,
        },
      },
      splitLine: {
        distance: 0,
        length: 35,
        lineStyle: {
          color: '#2B2F32',
        },
      },
      progress: {
        show: true,
        width: 14,
        itemStyle: {
          color: '#B5F7FF',
        },
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        show: false,
      },
      pointer: {
        show: false,
      },
      title: {
        show: false,
      },
      detail: {
        valueAnimation: true,
        fontSize: 72,
        lineHeight: 48,
        color: '#B5F7FF',
        fontWeight: 200,
        formatter: (value) => `${formatter.format(value)}\n{small|OCX/min}`,
        rich: {
          small: {
            color: '#B5F7FF',
            fontSize: 24,
          },
        },
        offsetCenter: [0, 0],
      },
      encode: {
        value: 'speed',
      },
    },
  ],
  textStyle: {
    fontFamily: 'NeueHaasDisplay,sans-serif',
  },
  animationDuration: 5_000,
  media: [
    {
      query: {
        maxWidth: 317,
      },
      option: {
        title: {
          textStyle: {
            fontSize: 11.96,
            lineHeight: 14.35,
          },
        },
        series: [
          {
            name: 'epoch',
            center: centerMiddle,
            startAngle,
            radius: 165,
            axisLine: {
              lineStyle: {
                color: [
                  [
                    1,
                    {
                      image: texture1680,
                    },
                  ],
                ],
              },
            },
            progress: {
              itemStyle: {
                color: {
                  image: frontTexture1680,
                },
              },
            },
            detail: {
              fontSize: 33,
              rich: {
                small: {
                  fontSize: 12,
                },
              },
              offsetCenter: [100, -140],
            },
          },
          {
            name: 'line',
            center: centerMiddle,
            radius: 70,
          },
          {
            name: 'shadow',
            center: centerMiddle,
            radius: 130,
          },
          {
            name: 'speed',
            center: centerMiddle,
            radius: 135,
            detail: {
              fontSize: 61.52,
              lineHeight: 36,
            },
          },
        ],
      },
    },
    {
      query: {
        maxWidth: 280,
      },
      option: {
        title: {
          left: 'center',
          textStyle: {
            fontSize: 10.54,
            lineHeight: 12.65,
          },
        },
        series: [
          {
            name: 'epoch',
            center: centerSmall,
            radius: 140,
            endAngle: 72,
            axisLine: {
              lineStyle: {
                color: [
                  [
                    1,
                    {
                      image: texture1279,
                    },
                  ],
                ],
              },
            },
            progress: {
              itemStyle: {
                color: {
                  image: frontTexture1279,
                },
              },
            },
            detail: {
              fontSize: 31.63,
              rich: {
                small: {
                  fontSize: 12,
                },
              },
              offsetCenter: [100, -110],
            },
          },
          {
            name: 'line',
            center: centerSmall,
            radius: 65,
          },
          {
            name: 'shadow',
            center: centerSmall,
            radius: 100,
            progress: {
              width: 35,
            },
          },
          {
            name: 'speed',
            center: centerSmall,
            radius: 110,
            splitLine: {
              length: 20,
            },
            detail: {
              fontSize: 54.23,
              lineHeight: 32,
            },
          },
        ],
      },
    },
  ],
}
